import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import {
	Stepper,
	Step,
	Button,
	Typography,
	StepConnector,
	Grid,
} from '@mui/material';

import 'date-fns';
import SettingsIcon from '@mui/icons-material/Settings';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import StepLabel from '@mui/material/StepLabel';
import PaymentIcon from '@mui/icons-material/Payment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import clsx from 'clsx';
import CampaignParentForm from './CampaignParentForm';
import CampaignTicker from './CampaignTicker';
import { RootState } from 'Stores/store';
import { useAppSelector } from 'Stores/Hooks/hooks';
import { makeStyles } from '@mui/styles';

const PREFIX = 'CampaignStepper';

const classes = {
    alternativeLabel: `${PREFIX}-alternativeLabel`,
    active: `${PREFIX}-active`,
    completed: `${PREFIX}-completed`,
    line: `${PREFIX}-line`,
    root: `${PREFIX}-root`,
    button: `${PREFIX}-button`,
    backButton: `${PREFIX}-backButton`,
    completed2: `${PREFIX}-completed2`,
    instructions: `${PREFIX}-instructions`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        width: '100%',
        padding:'24px',
    },

    [`& .${classes.button}`]: {
        marginRight: theme.spacing(1),
    },

    [`& .${classes.backButton}`]: {
        marginRight: theme.spacing(1),
    },

    [`& .${classes.completed2}`]: {
        display: 'inline-block',
    },

    [`& .${classes.instructions}`]: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    }
}));

function getSteps() {
	return ['Campaign', 'Advertisements', 'Payments', 'Review'];
}

export default function CampaignStepper({
	action,
	role,
}: {
	action: any;
	role?: string;
}) {
	// Default

	const [activeStep, setActiveStep] = React.useState(0);
	const [completed, setCompleted] = React.useState(new Set());
	const [skipped, setSkipped] = React.useState(new Set());

	const steps = getSteps();
	const { mode } = useAppSelector((state: RootState) => state.campaign);

	useEffect(() => {
		if (mode === 'VIEW') {
			setActiveStep(totalSteps() - 1);
		}
	}, [mode]);

	function getStepContent(step: any) {
		return (
			<CampaignParentForm
				action={mode}
				activeStep={step}
				handleNext={handleNext}
				handleBack={handleBack}
				role={role}
			/>
		);
	}

	const totalSteps = () => {
		return getSteps().length;
	};

	const isStepOptional = (prop: any) => {
		//return step === 1;
		return false;
	};

	const skippedSteps = () => {
		return skipped.size;
	};

	const completedSteps = () => {
		return completed.size;
	};

	const allStepsCompleted = () => {
		return completedSteps() === totalSteps() - skippedSteps();
	};

	const isLastStep = () => {
		return activeStep === totalSteps() - 1;
	};

	const handleNext = () => {
		const newActiveStep =
			isLastStep() && !allStepsCompleted()
				? // It's the last step, but not all steps have been completed
				  // find the first step that has been completed
				  steps.findIndex((step, i) => !completed.has(i))
				: activeStep + 1;

		setActiveStep(newActiveStep);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleReset = () => {
		setActiveStep(0);
		setCompleted(new Set());
		setSkipped(new Set());
	};

	const isStepSkipped = (step: any) => {
		return skipped.has(step);
	};

	return <>
        <Grid container xs={12} style={{width:"100%",padding:"20px",}}>
            <Grid item xs={10} style={{ backgroundColor:'#fff'}}>
                <Root className={classes.root}>
                    <Stepper
                        alternativeLabel
                        activeStep={activeStep}
                        connector={<ColorlibConnector
                            classes={{
                                alternativeLabel: classes.alternativeLabel,
                                active: classes.active,
                                completed: classes.completed,
                                line: classes.line
                            }} />}>
                        {steps.map((label: any, index: any) => {
                            const stepProps: any = {};
                            const buttonProps: any = {};
                            if (isStepOptional(index)) {
                                buttonProps.optional = (
                                    <Typography variant="caption">
                                        Optional
                                    </Typography>
                                );
                            }
                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Root>
            </Grid>
            <Grid item xs={2}>
                <CampaignTicker />
            </Grid>
        </Grid>
        <div style={{padding:'20px'}}>
            {allStepsCompleted() ? (
                <div>
                    <Typography className={classes.instructions}>
                        All steps completed - you&apos;re finished
                    </Typography>
                    <Button onClick={handleReset}>Reset</Button>
                </div>
            ) : (
                <div>
                    {getStepContent(activeStep)}
                    {/* <div>
          <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            className={classes.button}
          >
            {activeStep === totalSteps() - 1 ? 'Submit' : 'Next'}
          </Button>
          {isStepOptional(activeStep) && !completed.has(activeStep) && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleSkip}
              className={classes.button}
            >
              Skip
            </Button>
          )}
         {activeStep !== steps.length &&
            (completed.has(activeStep) ? (
              <Typography variant="caption" className={classes.completed}>
                Step {activeStep + 1} already completed
              </Typography>
            ) : (
              <Button variant="contained" color="primary" onClick={handleComplete}>
                {completedSteps() === totalSteps() - 1 ? 'Submit' : 'Next'}
              </Button>
            ))}
        </div> */}
                </div>
            )}
        </div>
    </>;
}

const ColorlibConnector = StepConnector;

const useColorlibStepIconStyles = makeStyles({
	root: {
		backgroundColor: '#ccc',
		zIndex: 1,
		color: '#fff',
		width: 50,
		height: 50,
		display: 'flex',
		borderRadius: '50%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	active: {
		backgroundColor: '#085DAD',
		boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
	},
	completed: {
		backgroundColor: '#0099cc',
	},
});

function ColorlibStepIcon(props: any) {
	const classes = useColorlibStepIconStyles();
	const { active, completed } = props;

	const icons: any = {
		1: <SettingsIcon />,
		2: <VideoLabelIcon />,
		3: <PaymentIcon />,
		4: <CheckCircleIcon />,
	};

	return (
		<div
			className={clsx(classes.root, {
				[classes.active]: active,
				[classes.completed]: completed,
			})}>
			{icons[String(props.icon)]}
		</div>
	);
}
